// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.verified-popup {
  padding: 50px 63px 50px 50px;
}
.verified-popup p {
  padding: 30px 0 50px 0;
}
.verified-popup .buttons {
  display: flex;
  justify-content: space-between;
}
.verified-popup .buttons > * {
  width: calc(50% - 1.2rem);
}
@media screen and (max-width: 719px) {
  .verified-popup .buttons {
    flex-direction: column;
  }
  .verified-popup .buttons > * {
    width: 100%;
  }
  .verified-popup .buttons > *:not(:last-child) {
    margin-bottom: 1.2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/kit/components/Popups/GetVerifiedPopup/index.scss"],"names":[],"mappings":"AAAA;EACE,4BAAA;AACF;AACE;EACE,sBAAA;AACJ;AAEE;EACE,aAAA;EACA,8BAAA;AAAJ;AACI;EACE,yBAAA;AACN;AAEI;EAPF;IAQI,sBAAA;EACJ;EAAI;IACE,WAAA;EAEN;EAAI;IACE,qBAAA;EAEN;AACF","sourcesContent":[".verified-popup {\n  padding: 50px 63px 50px 50px;\n\n  p {\n    padding: 30px 0 50px 0;\n  }\n\n  .buttons {\n    display: flex;\n    justify-content: space-between;\n    & > * {\n      width: calc(50% - 1.2rem);\n    }\n\n    @media screen and (max-width: 719px) {\n      flex-direction: column;\n      & > * {\n        width: 100%;\n      }\n      & > *:not(:last-child) {\n        margin-bottom: 1.2rem;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
